module.exports = __webpack_public_path__ + "assets/shape-octagon.f2920cf6.svg";